import { DISPLAY_NONE, DISPLAY_INLINE_BLOCK } from '../../constants';
import { performWhenDesktopResolution } from '../../../utils/ifElse';
import {
    onSwitchToDesktop,
    onSwitchFromDesktop,
    onSwitchToLargeDesktop,
} from '../../../utils/resizeObserver';
import { isHighResolution } from '../../../utils/isHighResolution';

const STASH_CLASS_NAME = 'breadcrumbs__stash';
const OPENING_CRUMBS_AMOUNT = 2;
const CRUMBS_AFTER_DOTS_DESKTOP = 2;
const CRUMBS_AFTER_DOTS_LARGE_DESKTOP = 3;

export const init = () => {
    const breadcrumbsBar = document.querySelector('.breadcrumbs__nav');
    const breadcrumbsList = breadcrumbsBar.querySelector('.breadcrumbs__list');
    const threeDots = breadcrumbsBar.querySelector('.breadcrumbs__three-dots');
    const threeDotsCotainer = threeDots.parentElement;

    const hideThreeDots = () => {
        threeDotsCotainer.style.display = DISPLAY_NONE;
    };
    const showThreeDots = () => {
        threeDotsCotainer.style.display = DISPLAY_INLINE_BLOCK;
    };

    const setupStash = ({ crumbsAfterDots }) => {
        const breadcrumbs = Array.from(breadcrumbsList.children);
        const MIN_CRUMBS_AMOUNT = OPENING_CRUMBS_AMOUNT + crumbsAfterDots;

        // comparing the min value + 1 because of three-dots-item presenting in the list
        if (breadcrumbs.length > MIN_CRUMBS_AMOUNT + 1) {
            showThreeDots();

            breadcrumbs.forEach((item, i) => {
                if (i > OPENING_CRUMBS_AMOUNT && i < breadcrumbs.length - crumbsAfterDots) {
                    item.classList.add(STASH_CLASS_NAME);
                } else if (i >= breadcrumbs.length - crumbsAfterDots) {
                    item.classList.remove(STASH_CLASS_NAME);
                }
            });

            return;
        }
        breadcrumbs.forEach(item => {
            item.classList.remove(STASH_CLASS_NAME);
        });
        hideThreeDots();
    };

    const checkBreadcrumbsState = () => {
        if (isHighResolution()) {
            setupStash({ crumbsAfterDots: CRUMBS_AFTER_DOTS_LARGE_DESKTOP });
            return;
        }
        setupStash({ crumbsAfterDots: CRUMBS_AFTER_DOTS_DESKTOP });
    };

    const toggleStashView = shouldShow => {
        const stashedBreadcrumbsItems = Array.from(
            breadcrumbsBar.querySelectorAll(`.${STASH_CLASS_NAME}`)
        );

        if (!stashedBreadcrumbsItems.length) {
            hideThreeDots();
        }
        stashedBreadcrumbsItems.forEach(element => {
            if (shouldShow) {
                const BREADCRUMB_ITEM_WIDTH = element.children[0].offsetWidth;
                element.style.transition = 'opacity 0.1s ease-in-out';
                element.style.opacity = '1';
                element.style.width = `${BREADCRUMB_ITEM_WIDTH}px`;
            } else {
                element.style.transition = '';
                element.style.opacity = '0';
                element.style.width = '0';
            }
        });
    };

    const setBreadcrumbsBarHeight = () => {
        breadcrumbsBar.style.height = `${breadcrumbsList.offsetHeight}px`;
    };

    onSwitchToDesktop(checkBreadcrumbsState);
    onSwitchFromDesktop(hideThreeDots);
    onSwitchToLargeDesktop(checkBreadcrumbsState);

    threeDots.addEventListener(
        'mouseenter',
        performWhenDesktopResolution(() => {
            hideThreeDots();
            toggleStashView(true);
            setBreadcrumbsBarHeight();
        })
    );

    let timerID = null;

    breadcrumbsBar.addEventListener('mouseenter', () => {
        clearTimeout(timerID);
    });

    breadcrumbsBar.addEventListener(
        'mouseleave',
        performWhenDesktopResolution(() => {
            timerID = setTimeout(() => {
                showThreeDots();
                toggleStashView();
                setBreadcrumbsBarHeight();
            }, 500);
        })
    );
};
